import { LeaderboardViewKey, LeaderboardViewType, ProfileSummary, UserData } from '../../../types';

export const getCurrentUserData = (
  viewType: LeaderboardViewKey,
  allTimeUserData?: ProfileSummary | null,
  campaignUserData?: UserData | null,
) => {
  return viewType === LeaderboardViewType.ALL_TIME ? allTimeUserData : campaignUserData;
};
